import { Heart } from "lucide-react";
import Logo from "@/components/Logo";
import { useAuth } from "@/contexts/AuthContext";
import { useNavigate, Link } from "react-router-dom";

const Footer = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  return (
    <footer className="bg-card border-t border-border py-12 px-4" data-testid="main-footer">
      <div className="container mx-auto">
        <div className="grid md:grid-cols-4 gap-8">
          <div className="col-span-1">
            <Logo 
              onClick={() => navigate(user ? '/dashboard' : '/')}
              className="mb-4"
            />
            <p className="text-muted-foreground text-sm">
              The AI-powered coloring page generator that brings creativity to life for kids, adults, and everyone in between.
            </p>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4">Product</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><a href="#generator" className="hover:text-foreground hover:cursor-pointer transition-colors font-inherit">AI Generator</a></li>
              <li><a href="#gallery" className="hover:text-foreground hover:cursor-pointer transition-colors font-inherit">Gallery</a></li>
              <li><a href="#pricing" className="hover:text-foreground hover:cursor-pointer transition-colors font-inherit">Pricing</a></li>
              <li><Link to="/api" className="hover:text-foreground hover:cursor-pointer transition-colors font-inherit text-left">API</Link></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4">Support</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/help" className="hover:text-foreground hover:cursor-pointer transition-colors font-inherit" data-testid="footer-help">Help Center</Link></li>
              <li><a href="mailto:support@skecha.com" className="hover:text-foreground hover:cursor-pointer transition-colors font-inherit">Contact Us</a></li>
              <li><Link to="/status" className="hover:text-foreground hover:cursor-pointer transition-colors font-inherit">Status</Link></li>
              <li><a href="https://discord.gg/skecha" className="hover:text-foreground hover:cursor-pointer transition-colors font-inherit" target="_blank" rel="noopener noreferrer">Community</a></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4">Company</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/about" className="hover:text-foreground hover:cursor-pointer transition-colors font-inherit" data-testid="footer-about">About</Link></li>
              <li><Link to="/privacy" className="hover:text-foreground hover:cursor-pointer transition-colors font-inherit" data-testid="footer-privacy">Privacy</Link></li>
              <li><Link to="/terms" className="hover:text-foreground hover:cursor-pointer transition-colors font-inherit" data-testid="footer-terms">Terms</Link></li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-border mt-8 pt-8 flex flex-col md:flex-row items-center justify-between">
          <p className="text-sm text-muted-foreground flex items-center gap-1">
            Made with <Heart className="w-4 h-4 text-red-500" /> for creativity
          </p>
          <p className="text-sm text-muted-foreground">
            © 2025 SKECHA. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;